module.exports = __webpack_public_path__ + "static/assets/42c3a5aa0d0adb8470fab8c983ac8b2e.svg";